import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BookingWidgetService {

    url: string = environment.api.endpoint;

    constructor(private http: HttpClient) { }

    getUserOrganization(apiKey){
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });
        return this.http.get(`${this.url}/bookingwidget/organization`, { headers: headers });
    }

    getSimulators(apiKey, data): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.get(`${this.url}/bookingwidget/simulators/`, { params: data, headers: headers });
    }

    getAvailableTimeSlots(apiKey: string, data): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.post(`${this.url}/bookingwidget/timeslots`, data, { headers: headers });
    }

    getAddons(apiKey: string, data): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.post(`${this.url}/bookingwidget/addons`, data, { headers: headers });
    }

    getBookingDurations(apiKey: string, data): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.get(`${this.url}/bookingwidget/bookingdurations`, { params: data, headers: headers });
    }

    createPaymentIntent(apiKey: string, data): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.post(`${this.url}/bookingwidget/create/paymentintent`, data, { headers: headers });
    }

    updatePaymentIntent(apiKey: string, data): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.post(`${this.url}/bookingwidget/update/paymentintent`, data, { headers: headers });
    }

    cancelPaymentIntent(apiKey: string, data): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.post(`${this.url}/bookingwidget/cancel/paymentintent`, data, { headers: headers });
    }

    createBooking(apiKey: string, data): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.post(`${this.url}/bookingwidget/create/booking`, data, { headers: headers });
    }

    createBookingMembership(apiKey: string, data): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.post(`${this.url}/bookingwidget/create/bookingmembership`, data, { headers: headers });
    }

    createCustomer(apiKey: string, data): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.post(`${this.url}/bookingwidget/customer/create`, data, { headers: headers });
    }

    validateMembershipDiscountCode(apiKey: string, data): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.post(`${this.url}/bookingwidget/membership/validate`, data, { headers: headers });
    }
}